var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "examples-in-use" }, [
    _c("div", { staticClass: "row align-bottom" }, [
      _c("div", [
        _c("h3", [_vm._v("Icons in Use")]),
        _vm._v(" "),
        _c("p", { staticClass: "line-length-lg" }, [
          _vm._v(
            "\n        Fake it 'til you make it, amiright? Here are some examples of how you could use Font Awesome\n        " +
              _vm._s(_vm.categoryLabel) +
              " icons in your projects, whether they're apps, interfaces, or print designs.\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row roomy padding-y-2xl align-stretch" }, [
      _c("div", { staticClass: "column-12 laptop:column-4 margin-bottom-xl" }, [
        _c(
          "div",
          {
            staticClass: "card padding-top-0",
            staticStyle: {
              "--card-background": "var(--category-color)",
              height: "100%",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "example-mobileapp",
                staticStyle: {
                  margin: "0 auto",
                  "background-color": "var(--category-color-alt)",
                  "border-radius":
                    "0 0 var(--border-radius-lg) var(--border-radius-lg)",
                },
              },
              [
                _c("h4", { staticClass: "sr-only" }, [
                  _vm._v("An example of a mobile app using icons"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "var(--spacing-md)",
                      color: "var(--category-color)",
                    },
                  },
                  [
                    _c("i", {
                      class: [
                        `fa-${_vm.selectedFamily} fas fa-${_vm.getIcon(
                          1
                        )} fa-fw fa-2x fa-fade`,
                      ],
                      staticStyle: { "--fa-animation-duration": "3s" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "size-lg strong display-block margin-top-xs",
                      },
                      [_vm._v("Loading...")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "display-flex align-between",
                    staticStyle: {
                      "background-color": "var(--fa-navy)",
                      padding: "var(--spacing-sm) var(--spacing-xs)",
                      "border-radius":
                        "0 0 var(--border-radius-lg) var(--border-radius-lg)",
                      "--button-border-radius": "var(--border-radius-lg)",
                      "--button-padding": "var(--button-padding-vertical)",
                    },
                  },
                  _vm._l(_vm.previewIcons, function (item, index) {
                    return _c(
                      "button",
                      {
                        key: item.previewIcons,
                        class: ["flat", { "laptop:display-none": index > 3 }],
                        staticStyle: {
                          "--button-hover-background":
                            "var(--category-color-alt)",
                          "--button-color": "var(--white)",
                          "--button-background": "var(--category-color-alt)",
                          "--button-margin-bottom": "0",
                        },
                      },
                      [
                        _c("i", {
                          class: [
                            `fa-${_vm.selectedFamily} ${item.style} fa-${item.icon} fa-fw fa-xl`,
                          ],
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("example button"),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
        },
        [
          _c(
            "div",
            {
              staticClass: "card display-flex align-center",
              staticStyle: {
                "flex-direction": "column",
                "--card-background": "var(--category-color-alt)",
                height: "100%",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "example-sign display-flex margin-bottom-lg",
                  staticStyle: {
                    "z-index": "2",
                    "border-radius": "var(--border-radius-md)",
                    "background-color": "var(--white)",
                  },
                },
                [
                  _c("h4", { staticClass: "sr-only" }, [
                    _vm._v("An example of a signs with icons"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-left text-truncate padding-x-md padding-y-lg laptop:padding-x-lg",
                      staticStyle: {
                        "flex-grow": "3",
                        color: "var(--category-color-alt)",
                      },
                    },
                    [
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } fas fa-fw fa-2xl fa-${_vm.getIcon(5)}`,
                        ],
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "margin-left-md",
                          staticStyle: { color: "var(--fa-navy-transparent5)" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.getIcon(5)) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sign display-flex margin-bottom-lg",
                  staticStyle: {
                    "z-index": "2",
                    "border-radius": "var(--border-radius-md)",
                    "background-color": "var(--white)",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-left text-truncate padding-x-md padding-y-lg laptop:padding-x-lg",
                      staticStyle: {
                        "flex-grow": "3",
                        color: "var(--category-color-alt)",
                      },
                    },
                    [
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } fas fa-fw fa-2xl fa-${_vm.getIcon(6)}`,
                        ],
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "margin-left-md",
                          staticStyle: { color: "var(--fa-navy-transparent5)" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.getIcon(6)) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(1),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "z-index": "1",
                    position: "absolute",
                    top: "0",
                    left: "15%",
                    width: "15px",
                    height: "65%",
                    "background-color": "var(--category-color)",
                  },
                },
                [_vm._v(" ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "z-index": "1",
                    position: "absolute",
                    top: "0",
                    right: "15%",
                    width: "15px",
                    height: "65%",
                    "background-color": "var(--category-color)",
                  },
                },
                [_vm._v(" ")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "card display-flex flex-column flex-content-end text-left padding-bottom-0",
              staticStyle: {
                "--card-background": "var(--category-color-alt)",
                height: "100%",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "example-todos text-capitalize text-center padding-xs",
                  staticStyle: {
                    color: "var(--category-color)",
                    "background-color": "var(--fa-navy)",
                    "border-radius":
                      "var(--border-radius-md) var(--border-radius-md) 0 0",
                  },
                },
                [
                  _c("h4", { staticClass: "sr-only" }, [
                    _vm._v("An example of a to-do list with icons"),
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.categoryLabel) +
                      " icons\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "background-color": "var(--white)" } },
                [
                  _c("ul", { staticClass: "fa-ul" }, [
                    _c(
                      "li",
                      {
                        staticStyle: {
                          padding: "var(--spacing-sm)",
                          "border-bottom": "1px solid var(--fa-gravy)",
                          color: "var(--category-color)",
                        },
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left text-truncate" }, [
                          _c("i", {
                            class: [
                              `fa-${
                                _vm.selectedFamily
                              } fas fa-fw fa-xl fa-${_vm.getIcon(1)}`,
                            ],
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "text-truncate margin-left-md" },
                            [_vm._v(_vm._s(_vm.getIcon(1)))]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticStyle: {
                          padding: "var(--spacing-sm)",
                          "border-bottom": "1px solid var(--fa-gravy)",
                        },
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left text-truncate" }, [
                          _c("i", {
                            class: [
                              `fa-${
                                _vm.selectedFamily
                              } fas fa-fw fa-xl fa-${_vm.getIcon(2)}`,
                            ],
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "text-truncate margin-left-md",
                              staticStyle: {
                                color: "var(--fa-navy-transparent5)",
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.getIcon(2)) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticStyle: { padding: "var(--spacing-sm)" } },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left text-truncate" }, [
                          _c("i", {
                            class: [
                              `fa-${
                                _vm.selectedFamily
                              } fas fa-fw fa-xl fa-${_vm.getIcon(3)}`,
                            ],
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "margin-left-md",
                              staticStyle: {
                                color: "var(--fa-navy-transparent5)",
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.getIcon(3)) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "column-12 laptop:column-6 margin-bottom-xl" }, [
        _c(
          "div",
          {
            staticClass:
              "card display-flex flex-column flex-content-end text-left padding-bottom-0",
            staticStyle: {
              "--card-background": "var(--category-color)",
              height: "100%",
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "examples-website display-flex padding-xs align-middle",
                staticStyle: {
                  color: "var(--category-color)",
                  "background-color": "var(--fa-navy)",
                  "border-radius":
                    "var(--border-radius-md) var(--border-radius-md) 0 0",
                },
              },
              [
                _c("h4", { staticClass: "sr-only" }, [
                  _vm._v("An example of a website with icons"),
                ]),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-center padding-x-4xl padding-y-4xs margin-x-2xl",
                    staticStyle: {
                      "flex-grow": "2",
                      opacity: "0.7",
                      "background-color": "var(--fa-dk-navy)",
                      "border-radius": "var(--border-radius-lg)",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.category) +
                        "-opedia\n          "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "display-flex",
                staticStyle: { "background-color": "var(--white)" },
              },
              [
                _c("div", { staticClass: "column-6 padding-lg" }, [
                  _c(
                    "span",
                    {
                      staticClass: "display-block strong margin-bottom-sm",
                      staticStyle: { color: "var(--category-color-alt)" },
                    },
                    [
                      _vm._v(
                        "\n              The web's premier resource for " +
                          _vm._s(_vm.categoryLabel) +
                          " icons.\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "display-block",
                      staticStyle: { color: "var(--fa-dk-gravy)" },
                    },
                    [
                      _vm._v(
                        "\n              Of all the fake websites in the world, this is the best.\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column-6 padding-lg" }, [
                  _c(
                    "div",
                    { staticClass: "display-flex align-between padding-md" },
                    [
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } ${_vm.getRandomStyle()} fa-${_vm.getIcon(
                            1
                          )} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--category-color-alt)" },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } ${_vm.getRandomStyle()} fa-${_vm.getIcon(
                            2
                          )} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--fa-navy)" },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } ${_vm.getRandomStyle()} fa-${_vm.getIcon(
                            3
                          )} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--category-color-alt)" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "display-flex align-between padding-md" },
                    [
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } ${_vm.getRandomStyle()} fa-${_vm.getIcon(
                            4
                          )} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--fa-navy)" },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } ${_vm.getRandomStyle()} fa-${_vm.getIcon(
                            5
                          )} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--category-color-alt)" },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } ${_vm.getRandomStyle()} fa-${_vm.getIcon(
                            6
                          )} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--fa-navy)" },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-6 margin-bottom-xl",
        },
        [
          _c(
            "div",
            {
              staticClass: "card padding-x-3xl laptop:padding-x-6xl",
              staticStyle: {
                "--card-background": "var(--fa-navy)",
                "--card-color": "var(--white)",
                height: "100%",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "examples-transitline display-flex flex-content-center flex-column",
                  staticStyle: { height: "100%" },
                },
                [
                  _c("h4", { staticClass: "sr-only" }, [
                    _vm._v("An example of a transit line using icons"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "display-flex flex-content-between" },
                    [
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } fas fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--category-color)" },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } fas fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--category-color)" },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } ${_vm.getRandomStyle()} fa-${_vm.getRandomIcon()} fa-fw fa-2x fa-beat-fade`,
                        ],
                        staticStyle: {
                          color: "var(--fa-gravy)",
                          "--fa-animation-duration": "2s",
                        },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } ${_vm.getRandomStyle()} fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                        staticStyle: { color: "var(--fa-gravy)" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(6),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "card display-flex flex-content-center flex-items-center",
              staticStyle: {
                color: "var(--white)",
                height: "100%",
                background:
                  "center / cover var(--fa-navy) url('https://img.fortawesome.com/1ce05b4b/background-bricks2.png') repeat",
              },
            },
            [
              _c("i", {
                class: [
                  `fa-${_vm.selectedFamily} fas fa-${_vm.categoryIcon} fa-fw fa-6x`,
                ],
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "card display-flex flex-column flex-content-end text-left padding-bottom-0 padding-x-2xl",
              staticStyle: {
                "--card-background": "var(--category-color)",
                height: "100%",
                overflow: "hidden",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "examples-flyer position-relative padding-x-xl padding-top-xl",
                  staticStyle: {
                    "background-color": "var(--white)",
                    "margin-bottom": "-2em",
                  },
                },
                [
                  _c("h4", { staticClass: "sr-only" }, [
                    _vm._v("An example of a flyer with icons"),
                  ]),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "display-flex flex-content-around padding-md",
                    },
                    [
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } fal fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${_vm.selectedFamily} ${
                            _vm.canUseThin ? "fat" : "far"
                          } fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } fal fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${_vm.selectedFamily} ${
                            _vm.canUseThin ? "fat" : "far"
                          } fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "display-flex flex-content-around padding-md",
                    },
                    [
                      _c("i", {
                        class: [
                          `fa-${_vm.selectedFamily} ${
                            _vm.canUseThin ? "fat" : "far"
                          } fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } fal fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${_vm.selectedFamily} ${
                            _vm.canUseThin ? "fat" : "far"
                          } fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                      }),
                      _vm._v(" "),
                      _c("i", {
                        class: [
                          `fa-${
                            _vm.selectedFamily
                          } fal fa-${_vm.getRandomIcon()} fa-fw fa-2x`,
                        ],
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "position-absolute",
                      staticStyle: {
                        opacity: "0.3",
                        top: "-0.5em",
                        left: "-1.5em",
                        height: "2em",
                        width: "4em",
                        "background-color": "var(--fa-navy-transparent5)",
                        transform: "rotate(-45deg)",
                      },
                    },
                    [_vm._v("\n             \n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "position-absolute",
                      staticStyle: {
                        opacity: "0.3",
                        top: "-0.5em",
                        right: "-1.5em",
                        height: "2em",
                        width: "4em",
                        "background-color": "var(--fa-navy-transparent5)",
                        transform: "rotate(45deg)",
                      },
                    },
                    [_vm._v("\n             \n          ")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-xl",
        },
        [
          _c(
            "div",
            {
              staticClass: "card",
              staticStyle: {
                "--card-background": "var(--category-color)",
                height: "100%",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "examples-buttons display-flex flex-column flex-content-center",
                  staticStyle: { height: "100%" },
                },
                [
                  _c("h4", { staticClass: "sr-only" }, [
                    _vm._v("An example of a buttons with icons"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "block",
                      staticStyle: {
                        "--button-active-background":
                          "var(--category-color-alt)",
                        "--button-hover-background": "var(--category-color)",
                      },
                    },
                    [
                      _c("i", {
                        class: [
                          `fa-${_vm.selectedFamily} fal fa-${_vm.getIcon(
                            1
                          )} fa-fw fa-xl margin-right-md`,
                        ],
                        staticStyle: { color: "var(--category-color-alt)" },
                      }),
                      _vm._v("\n            Make It So\n          "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "block active",
                      staticStyle: {
                        "--button-active-background":
                          "var(--category-color-alt)",
                        "--button-hover-background": "var(--category-color)",
                      },
                    },
                    [
                      _c("i", {
                        class: [
                          `fa-${_vm.selectedFamily} fal fa-${_vm.getIcon(
                            1
                          )} fa-fw fa-xl margin-right-md fa-spin`,
                        ],
                        staticStyle: {
                          color: "var(--white)",
                          "--fa-animation-duration": "2s",
                        },
                      }),
                      _vm._v("\n            Making It So\n          "),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          padding: "var(--spacing-lg)",
          "background-color": "var(--fa-navy)",
          color: "var(--white)",
          "border-radius":
            "0 var(--border-radius-md) var(--border-radius-md) 0",
        },
      },
      [_c("i", { staticClass: "fas fa-fw fa-xl fa-arrow-up" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          padding: "var(--spacing-lg)",
          "background-color": "var(--fa-navy)",
          color: "var(--white)",
          "border-radius":
            "0 var(--border-radius-md) var(--border-radius-md) 0",
        },
      },
      [_c("i", { staticClass: "fas fa-fw fa-xl fa-arrow-right" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-li" }, [
      _c("i", { staticClass: "far fa-check-square" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-li" }, [
      _c("i", {
        staticClass: "far fa-square",
        staticStyle: { color: "var(--category-color)" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-li" }, [
      _c("i", {
        staticClass: "far fa-square",
        staticStyle: { color: "var(--category-color)" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "display-flex align-middle" }, [
      _c(
        "div",
        {
          staticClass: "display-inline-block margin-left-3xs",
          staticStyle: {
            width: "15px",
            height: "15px",
            "background-color": "var(--fa-dk-navy)",
            "border-radius": "var(--border-radius-lg)",
          },
        },
        [_vm._v("\n               \n            ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "display-inline-block margin-left-3xs",
          staticStyle: {
            width: "15px",
            height: "15px",
            "background-color": "var(--fa-dk-navy)",
            "border-radius": "var(--border-radius-lg)",
          },
        },
        [_vm._v("\n               \n            ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "display-inline-block margin-left-3xs",
          staticStyle: {
            width: "15px",
            height: "15px",
            "background-color": "var(--fa-dk-navy)",
            "border-radius": "var(--border-radius-lg)",
          },
        },
        [_vm._v("\n               \n            ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "position-relative display-flex margin-y-3xl margin-x-sm size-xs",
        staticStyle: { height: "1em" },
      },
      [
        _c(
          "div",
          {
            staticClass: "position-absolute z-index-2",
            staticStyle: {
              top: "-0.5em",
              left: "0",
              border: "0.5em solid var(--white)",
              height: "2em",
              width: "2em",
              "border-radius": "var(--border-radius-lg)",
              "background-color": "var(--category-color)",
            },
          },
          [_vm._v("\n               \n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "padding-4xs",
            staticStyle: {
              "flex-grow": "2",
              background: "var(--white)",
              "border-radius": "var(--border-radius-lg)",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "border-top": "0.5em solid var(--category-color)",
                  height: "1px",
                },
              },
              [_vm._v(" ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "position-absolute z-index-2",
            staticStyle: {
              top: "-0.5em",
              left: "31%",
              border: "0.5em solid var(--white)",
              height: "2em",
              width: "2em",
              "border-radius": "var(--border-radius-lg)",
              "background-color": "var(--category-color)",
            },
          },
          [_vm._v("\n               \n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "padding-4xs",
            staticStyle: {
              "flex-grow": "2",
              background: "var(--white)",
              "border-radius": "var(--border-radius-lg)",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "border-top": "0.5em dotted var(--category-color)",
                  height: "1px",
                },
              },
              [_vm._v(" ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "position-absolute z-index-2",
            staticStyle: {
              top: "-0.5em",
              right: "31%",
              border: "0.5em solid var(--white)",
              height: "2em",
              width: "2em",
              "border-radius": "var(--border-radius-lg)",
              "background-color": "var(--category-color)",
            },
          },
          [_vm._v("\n               \n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "padding-4xs",
            staticStyle: {
              "flex-grow": "2",
              background: "var(--white)",
              "border-radius": "var(--border-radius-lg)",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "border-top": "0.5em solid var(--white)",
                  height: "1px",
                },
              },
              [_vm._v(" ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "position-absolute z-index-2",
            staticStyle: {
              top: "-0.5em",
              right: "0",
              border: "0.5em solid var(--white)",
              height: "2em",
              width: "2em",
              "border-radius": "var(--border-radius-lg)",
              "background-color": "var(--category-color)",
            },
          },
          [_vm._v("\n               \n            ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "padding-x-lg text-center" }, [
      _c(
        "span",
        {
          staticClass:
            "display-block size-xl strong text-uppercase margin-bottom-xs",
          staticStyle: { color: "var(--category-color-alt)" },
        },
        [_vm._v("\n              Icons For Sale\n            ")]
      ),
      _vm._v(" "),
      _c("small", { staticClass: "display-block muted" }, [
        _vm._v(
          "Fresh, hot icons for sale! Call us at (555) 867-5309 for more info."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }